/* eslint-disable camelcase */
import Model from '../../../Api/Models/Model';
import User from '../../../Api/Models/User';
import { CasinoDepositBonus } from '../../../crm/casino/Models/CasinoDepositBonus';

import CasinoFreespinCampaign from './CasinoFreespinCampaign';

export default class CasinoUserBonus extends Model {
    readonly id: number;
    readonly casino_freespin_campaign_id?: number;
    readonly casino_deposit_bonus_id?: number;
    readonly user_id: number;
    readonly currency_code: string;
    readonly stored_balance_bonus: number;
    readonly external_token: string;
    readonly is_ready_to_check: boolean;
    readonly is_checked: boolean;
    readonly is_prize_received: boolean;
    readonly did_user_fill_requirements: boolean;
    readonly has_no_wins: boolean;
    readonly has_used_all_freespins: boolean;
    readonly activated_at: string;
    readonly activated_until: string;
    readonly check_data?: JSON;
    readonly updated_at: string;
    readonly created_at: string;

    // Relationships
    readonly user?: User;
    readonly casino_deposit_bonus?: CasinoDepositBonus;
    readonly freespin_campaign?: CasinoFreespinCampaign;

    constructor(transaction: Partial<CasinoUserBonus>) {
        super();
        this.assignDataToProps(transaction, [
            'id',
            'casino_freespin_campaign_id',
            'casino_deposit_bonus_id',
            'user_id',
            'currency_code',
            'stored_balance_bonus',
            'external_token',
            'is_ready_to_check',
            'is_checked',
            'is_prize_received',
            'did_user_fill_requirements',
            'has_no_wins',
            'has_used_all_freespins',
            'activated_at',
            'activated_until',
            'check_data',
            'updated_at',
            'created_at',
            'user',
            'casino_deposit_bonus',
            'freespin_campaign',
        ]);
    }
}
